import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { OrderProductKeyAttributeSnapshot } from './OrderProductKeyAttributeSnapshot'
import { ShowcaseReviewReplyDto } from './ShowcaseReviewReplyDto'
import { ReviewStatus, ReviewRejectReason } from './Enums'
/**
* Class ShowcaseMyReviewDto
*  Свой отзыв — со статусом модерации.
*/
export class ShowcaseMyReviewDto extends ActiveModel {

  /**
  * id
  * Идентификатор.  */
  @ActiveField(0)
  id: number = 0


  /**
  * rating
  * Оценка 1–5.  */
  @ActiveField(0)
  rating: number = 0


/**
  * pros
  * Достоинства.
  */
  @ActiveField()
  pros?: null | string


/**
  * cons
  * Недостатки.
  */
  @ActiveField()
  cons?: null | string


/**
  * text
  * Комментарий.
  */
  @ActiveField()
  text?: null | string


/**
  * authorName
  * Публичное имя автора («Имя Ф.» или «Покупатель», если имя скрыто).
  */
  @ActiveField('')
  authorName: string = ''


  /**
  * isVerifiedPurchase
  * Отзыв подкреплён завершённой покупкой.  */
  @ActiveField(false)
  isVerifiedPurchase: boolean = false


/**
  * @property keyAttributes
  * Ключевые атрибуты варианта (размер, цвет).  */
  @ActiveField({
    factory: [OrderProductKeyAttributeSnapshot, () => []]
  })
  keyAttributes: Array<OrderProductKeyAttributeSnapshot> = []


/**
  * imageIds
  * Фото — id ресурсов в порядке показа.  */
  @ActiveField({
    setter(model: ShowcaseMyReviewDto, prop: string, value: Array<string>, receiver?: ShowcaseMyReviewDto ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => String(v)) : value,
        
        receiver)
    }
  })
  imageIds: Array<string> = []


/**
  * date
  * Дата публикации (для своих неопубликованных — дата создания).
  */
  @ActiveField('')
  date: string = ''


  /**
  * reply
  * Ответ магазина.  */
  @ActiveField({
    factory: [ShowcaseReviewReplyDto, () => undefined]
  })
  reply?: null | ShowcaseReviewReplyDto


  /**
  * productId
  * Вариант, на который оставлен отзыв.  */
  @ActiveField(0)
  productId: number = 0


/**
  * productName
  * Название товара. У отзыва по покупке — название на момент покупки из позиции заказа (как в reviewable-items),<br>без покупки — текущее название варианта: на этой витрине, иначе на витрине отзыва, иначе мастер-значение;<br>пустая строка, если названия нет нигде. Товар, удалённый после отзыва, по-прежнему отдаёт название.<br>
  */
  @ActiveField('')
  productName: string = ''


/**
  * productImageIds
  * Изображения варианта на текущей витрине, в порядке показа (как в reviewable-items) — для миниатюры.<br>Не путать с Web.Api.Showcases.Controllers.Reviews.Models.ShowcaseReviewDto.ImageIds — фото самого отзыва<br>  */
  @ActiveField({
    setter(model: ShowcaseMyReviewDto, prop: string, value: Array<string>, receiver?: ShowcaseMyReviewDto ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => String(v)) : value,
        
        receiver)
    }
  })
  productImageIds: Array<string> = []


  /**
  * status
  * словарь значений публикуется под именем `Domain.Entities.Reviews.ReviewStatus`  *   * Статус модерации.  *   * - `Pending` На проверке  *   * Ожидает модерации.  * - `Published` Опубликован  *   * Опубликован.  * - `Rejected` Отклонён  *   * Отклонён или скрыт модератором.  *   */
  @ActiveField(ReviewStatus.PENDING)
  status: ReviewStatus = ReviewStatus.PENDING


  /**
  * rejectReason
  * Причина отклонения.  */
  @ActiveField()
  rejectReason?: null | ReviewRejectReason


/**
  * rejectComment
  * Комментарий модератора к отклонению.
  */
  @ActiveField()
  rejectComment?: null | string


  /**
  * hideAuthorName
  * Автор попросил не показывать имя.  */
  @ActiveField(false)
  hideAuthorName: boolean = false
}
